import { useEffect, RefObject } from 'react'

// The 3D model-viewer element renders inside the mobile-emulation iframe, so its script
// must be injected into that frame's document, not the top one.
export default function useLoadScriptInFrame(
  scriptUrl: string,
  componentRef: RefObject<HTMLElement>,
  enabled: boolean
) {
  useEffect(() => {
    if (!scriptUrl || !enabled) return

    const inject = () => {
      const doc = componentRef.current?.ownerDocument
      if (!doc) return false
      if (!doc.head.querySelector(`script[src="${scriptUrl}"]`)) {
        const script = doc.createElement('script')
        script.type = 'module'
        script.src = scriptUrl
        doc.head.appendChild(script)
      }
      return true
    }

    if (inject()) return
    // The ref target lives in a Dialog portalled into the emulated iframe; when that mounts later,
    // nothing re-runs this effect (refs are not deps) — so poll until the node exists.
    const intervalId = window.setInterval(() => inject() && clearInterval(intervalId), 500)
    return () => clearInterval(intervalId)
  }, [scriptUrl, componentRef, enabled])
}
